import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-individual-entity-dialog',
  templateUrl: './individual-entity-dialog.component.html',
  styleUrls: ['./individual-entity-dialog.component.css']
})
export class IndividualEntityDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
